<dashboard-dialog-frame [icon]='icon()' header='Set Deck Submitted Date' [actions]='[]' [dialogRef]='dialogRef'>

	<div class="final-presentation-set-deck-submitted-date-dialog d-flex flex-column gap-5">
		<div>
			<readonly-access [readonly]="isReadonly()"></readonly-access>
			<table style='width:100%'
				class='pro-table pro-table-no-header pro-table-with-labels pro-table-without-border'>
				<tr>
					<td style="width: 20%;">Date</td>
					<td>
						<common-date-time-field [field]="deckSubmittedDate()"></common-date-time-field>
					</td>
				</tr>
			</table>
		</div>
		<common-button-row [center]="true">
			<button #dateFormSaveBtn class="btn btn-primary">Update</button>
			<button class="btn btn-danger" (click)="delete()" [disabled]="!deckSubmittedUTC()">Delete</button>
			<button class="btn btn-standard" (click)="close()">Close</button>
		</common-button-row>
	</div>
</dashboard-dialog-frame>